/* PANAS — animations au scroll (révélations, épinglé, rail) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return window.innerWidth < 900; };

  /* ---------- 1. Révélations en cascade ---------- */
  function initReveals() {
    if (reduce) return;
    var groups = [
      '.panas-preuves__item, .panas-preuves .preuve',
      '.panas-col__card',
      '.phab-card',
      '.pab-card',
      '.pv4-hero__achat > *',
      '.pv4-lot__inner > *',
      '.pv4-mini',
      '.panas-fil__inner > *',
      '.pab-strip__item',
      '.panas-col__title, .panas-col__subtitle'
    ];
    var els = [];
    groups.forEach(function (sel) {
      var found = document.querySelectorAll(sel);
      for (var i = 0; i < found.length; i++) {
        if (els.indexOf(found[i]) === -1) {
          found[i].classList.add('pns-rv');
          found[i].style.transitionDelay = Math.min(i, 5) * 0.07 + 's';
          els.push(found[i]);
        }
      }
    });
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pns-on'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Section épinglée : packshot fixe, récit qui défile ---------- */
  function initPin() {
    var sec = document.querySelector('[data-pns-pin]');
    if (!sec) return;
    var visuels = sec.querySelectorAll('.pnsr__vis');
    var steps = sec.querySelectorAll('.pnsr__step');
    if (!visuels.length || !steps.length) return;

    function activate(i) {
      for (var v = 0; v < visuels.length; v++) {
        visuels[v].classList.toggle('is-on', v === i);
      }
      for (var s = 0; s < steps.length; s++) {
        steps[s].classList.toggle('is-on', s === i);
      }
    }
    activate(0);
    if (reduce) { for (var v = 0; v < visuels.length; v++) visuels[v].classList.add('is-on'); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.intersectionRatio > 0.5) {
          activate(parseInt(e.target.getAttribute('data-i'), 10));
        }
      });
    }, { threshold: [0.5] });
    steps.forEach(function (st) { io.observe(st); });
  }

  /* ---------- 3. Rail horizontal épinglé ---------- */
  var railSec, rail, ticking = false;
  function initRail() {
    railSec = document.querySelector('[data-pns-rail]');
    if (!railSec) return;
    rail = railSec.querySelector('.pnsx__rail');
    if (!rail) return;
    sizeRail();
    window.addEventListener('resize', sizeRail);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  function sizeRail() {
    if (!railSec || !rail) return;
    if (reduce || isMobile()) {
      railSec.style.height = 'auto';
      rail.style.transform = 'none';
      return;
    }
    var dist = rail.scrollWidth - window.innerWidth + 60;
    railSec.style.height = (window.innerHeight + Math.max(dist, 0)) + 'px';
  }
  function onScroll() {
    if (ticking || !railSec || !rail) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (reduce || isMobile()) return;
      var r = railSec.getBoundingClientRect();
      var total = railSec.offsetHeight - window.innerHeight;
      if (total <= 0) return;
      var p = Math.min(Math.max(-r.top / total, 0), 1);
      var dist = rail.scrollWidth - window.innerWidth + 60;
      rail.style.transform = 'translate3d(' + (-p * dist) + 'px,0,0)';
    });
  }

  function boot() { initReveals(); initPin(); initRail(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
